<template lang="pug">
el-dialog#modal-cadastrar-monitoramento-agricola(
    width='500px',
    :visible.sync='mostrar',
    :before-close='fechar',
    :close-on-click-modal='false',
    :close-on-press-escape='false',
    :destroy-on-close='true',
    close='fechar'
)
    span(slot='title')
        h1.font-weight-bold Editar monitoramento agrícola
        h3.font {{ areaMonitorada?.territorio?.nome }}

    el-form.formContainer.w-100.mb-3.p-0(
        :model='dadosMonitoramento',
        :rules='rules',
        ref='formularioAreasMonitoramento'
    )
        el-form-item.my-3(
            prop='idSafra',
            :label='$t("mensagens.territorio.cicloAno")'
        )
            el-select.w-100(
                v-model='dadosMonitoramento.idSafra',
                :placeholder='$t("mensagens.territorio.selecione")',
                value-key='descricao'
            )
                el-option(
                    v-for='ciclo in cicloAno',
                    :key='`ciclo-ano-${ciclo.id}`',
                    :value='ciclo.id',
                    :label='ciclo.safraAno'
                )

        el-form-item.my-3(prop='cultura', label='Cultura esperada')
            el-select.w-100(
                v-model='dadosMonitoramento.cultura',
                :placeholder='$t("mensagens.territorio.selecione")',
                :disabled='!dadosMonitoramento.idSafra',
                clearable
            )
                el-option(
                    v-for='cultura in culturas',
                    :key='"cultura" + cultura.id',
                    :value='cultura.id',
                    :label='cultura.nome'
                ) {{ cultura.nome }}

        el-form-item.my-3(prop='cultura', label='Cultura esperada')
            el-select.w-100(
                v-model='dadosMonitoramento.cultura',
                :placeholder='$t("mensagens.territorio.selecione")',
                :disabled='!dadosMonitoramento.idSafra',
                clearable
            )
                el-option(
                    v-for='cultura in culturas',
                    :key='"cultura" + cultura.id',
                    :value='cultura.id',
                    :label='cultura.nome'
                ) {{ cultura.nome }}

        el-form-item.my-3(
            prop='dataPlantio',
            :label='$t("mensagens.territorio.dataPlantioEsperada")'
        )
            el-date-picker.w-100(
                :disabled='!dadosMonitoramento.cultura',
                v-model='dadosMonitoramento.dataPlantio',
                type='date',
                format='dd/MM/yyyy',
                value-format='yyyy-MM-dd',
                placeholder='',
                clearable
            )

        el-form-item.my-3.inline(
            prop='areaDoPlantio',
            :label='$t("mensagens.territorio.areaPlantioEsperada")'
        )
            el-input-number(
                :disabled='!dadosMonitoramento.cultura',
                v-model='dadosMonitoramento.areaDoPlantio',
                :precision='2',
                :step='0.01',
                :min='0.0'
            )

        el-form-item.my-3.inline(
            prop='produtividade',
            :label='$t("mensagens.territorio.produtividadeEsperada") + formatarUnidadeDeProdutividade()'
        )
            el-input-number(
                :disabled='!dadosMonitoramento.cultura',
                v-model='dadosMonitoramento.produtividade',
                :precision='2',
                :step='0.01',
                :min='0.0'
            )

    div(slot='footer')
        .buttons
            el-button(size='mini', @click='fechar')
                | Cancelar
            el-button(
                type='primary',
                size='mini',
                @click='confirmarMonitoramento'
            )
                | Confirmar
</template>

<script>
import UtilsService from '@/services/UtilsService';
export default {
    name: 'ModalEditarMonitoramentoAgricola',
    emits: ['cadastrarMonitoramentoAgricola'],
    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        areaMonitorada: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            algodao: null,
            rules: {
                idSafra: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'blur'
                    }
                ]
            },
            todasCulturas: [],
            culturas: [],
            cicloAno: [],
            dadosMonitoramento: {
                cultura: null,
                idSafra: null,
                dataPlantio: null,
                areaDoPlantio: 0,
                produtividade: 0
            }
        };
    },

    mounted() {
        this.buscarCulturas();
        this.buscarSafras();
    },

    watch: {
        mostrar: function () {
            if (this.mostrar) {
                this.preencherCampos();
            } else {
                this.limparCampos();
            }
        },
        'dadosMonitoramento.idSafra'(novoId) {
            if (novoId) {
                this.filtrarCulturasPorSafra(novoId);
            }
        }
    },

    methods: {
        filtrarCulturasPorSafra(idSafra) {
            const cicloSelecionado = this.cicloAno.find(c => c.id === idSafra);
            if (!cicloSelecionado) return;

            const tipoSafra = cicloSelecionado.safra;

            if (tipoSafra === 'SAFRA') {
                this.culturas = this.todasCulturas.filter(c =>
                    ['Soja', 'Milho'].includes(c.nome)
                );
            } else if (tipoSafra === 'SAFRINHA') {
                this.culturas = this.todasCulturas.filter(c =>
                    ['Soja', 'Milho', 'Algodão'].includes(c.nome)
                );
            } else {
                this.culturas = this.todasCulturas;
            }

            const culturaValida = this.culturas.some(
                c => c.id === this.dadosMonitoramento.cultura
            );
            if (!culturaValida) {
                this.dadosMonitoramento.cultura = null;
            }
        },

        buscarCulturas() {
            UtilsService.getCulturas()
                .then(({ data }) => {
                    const culturasProcessadas = Object.values(data).sort(
                        (a, b) => a.nome.localeCompare(b.nome)
                    );

                    this.todasCulturas = culturasProcessadas;
                    this.culturas = culturasProcessadas;

                    const algodao = culturasProcessadas.find(
                        c => c.nome === 'Algodão'
                    );
                    if (algodao) this.algodao = algodao.id;

                    if (this.dadosMonitoramento.idSafra) {
                        this.filtrarCulturasPorSafra(
                            this.dadosMonitoramento.idSafra
                        );
                    }
                })
                .catch(error => {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.territorio.naoFoiPossivelBuscarOsDadosDeCultura'
                        )
                    });
                    throw error;
                });
        },
        filtrarSafrasAtuais(safras) {
            const currentYear = new Date().getFullYear();
            const safrasFiltradas = safras.filter(
                safras => safras.ano >= currentYear
            );
            return safrasFiltradas;
        },
        buscarSafras() {
            UtilsService.getSafras().then(response => {
                if (response.status === 200) {
                    this.cicloAno = this.filtrarSafrasAtuais(response.data);
                } else {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.territorio.erroAoBuscarSafras'
                        )
                    });
                }
            });
        },

        fechar() {
            this.limparCampos();
            this.$emit('fechar');
        },
        confirmarMonitoramento() {
            this.$refs.formularioAreasMonitoramento.validate(async valid => {
                if (valid) {
                    if (!this.dadosMonitoramento.cultura) {
                        const culturaOutros = this.todasCulturas.find(
                            c => c.codigo === 'OUTROS'
                        );
                        if (culturaOutros) {
                            this.dadosMonitoramento.cultura = culturaOutros.id;
                        } else {
                            this.dadosMonitoramento.cultura = null;
                        }
                    }

                    const area = {
                        id: this.areaMonitorada.id,
                        idTerritorio: this.areaMonitorada.territorio.id,
                        dataPlantio: this.dadosMonitoramento.dataPlantio,
                        cultura: this.dadosMonitoramento.cultura,
                        idSafra: this.dadosMonitoramento.idSafra,
                        areaDoPlantio: this.dadosMonitoramento.areaDoPlantio,
                        produtividade: this.dadosMonitoramento.produtividade,
                        tipoMonitoramento: 'AGRICOLA'
                    };

                    this.$emit('editarMonitoramentoAgricola', area);

                    this.fechar();
                }
            });
        },
        limparCampos() {
            this.dadosMonitoramento = {
                cultura: null,
                idSafra: null,
                dataPlantio: null,
                areaDoPlantio: 0,
                produtividade: 0
            };
        },
        preencherCampos() {
            this.dadosMonitoramento.idSafra = this.areaMonitorada.safra.id;

            if (
                this.areaMonitorada.culturaEsperada &&
                this.areaMonitorada.culturaEsperada.id !== 0
            ) {
                this.dadosMonitoramento.cultura =
                    this.areaMonitorada.culturaEsperada.id;
            }

            if (this.areaMonitorada.dataPlantioEsperada) {
                const dataSplit =
                    this.areaMonitorada.dataPlantioEsperadaFormatado.split('/');
                this.dadosMonitoramento.dataPlantio =
                    dataSplit[2] + '-' + dataSplit[1] + '-' + dataSplit[0];
            }

            if (this.areaMonitorada.areaPlantadaEsperadaHa) {
                this.dadosMonitoramento.areaDoPlantio =
                    this.areaMonitorada.areaPlantadaEsperadaHa;
            }

            if (this.areaMonitorada.produtividadeEsperadaScHa) {
                this.dadosMonitoramento.produtividade =
                    this.areaMonitorada.produtividadeEsperadaScHa;
            }
        },
        formatarUnidadeDeProdutividade() {
            return this.dadosMonitoramento.cultura !== null &&
                this.dadosMonitoramento.cultura === this.algodao
                ? ' (@/ha)'
                : ' (sc/ha)';
        }
    }
};
</script>

<style lang="scss">
#modal-cadastrar-monitoramento-agricola {
    border-radius: 5px;

    .el-dialog__header {
        background-color: #e9e9e9;
        padding-bottom: 20px;
    }

    .el-dialog__body {
        padding: 0 20px 30px;

        .inline {
            .el-form-item__content {
                text-align: end;
            }
        }
    }

    .el-dialog__footer {
        .buttons {
            display: flex;
            justify-content: space-between;
        }
    }
}
</style>
